<script>
export default {
  name: "ProductHover.vue",
  props: {
    visible: Boolean
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('updateVisible', val)
      }
    }
  },
  data() {
    return {
      food: [
        'home', 'about', 'wedding-information', 'contact'
      ],
      coffee: [
        'home',
        'product',
        'coffee',
        'shop',
        'gourmet',
        'boutique',
        'history',
      ]
    }
  },
  methods: {
    openHover(name) {
      let pageFlags = ['home', 'gourmet', 'boutique', 'history'];
      if (pageFlags.includes(name)) {
        window.open('#/coffee/' + name)
      } else {
        window.open('#/coffee/home?scroll=' + name)
      }
    }
  }
}
</script>

<template>
  <div class="w-full flex shadow-md text-white z-80 overflow-hidden transition-all"
       :style="{maxHeight: show?'23rem':'0px'}" @mousemove="show = true"
       @mouseleave="show = false">
    <div class="w-1/3 flex justify-center">
      <div class="flex items-center">
        <div class="cursor-pointer hover:underline text-md">
          <!--          <a :href="'http://localhost:8888/#/home?locale='+$i18n.locale"-->
          <!--             target="_blank">{{ $t('group.header.hover.food.title') }}</a>-->
          <a :href="'/libaoge/#/home?locale='+$i18n.locale" target="_blank" class="block text-center">
            <span>{{ $t('group.header.hover.food.title') }}</span>
            <img src="@/assets/food-main.jpeg" class="mt-1 w-28 h-24" alt="">
          </a>
        </div>
        <ul class="ml-16">
          <li v-for="(item, index) in food" :key="index" class="py-1 cursor-pointer hover:underline text-md">
            <a target="_blank" :href="`https://kafelaku.com.hk/libaoge/#/${item}?locale=`+$i18n.locale">{{
                $t('group.header.hover.food.' + item)
              }}</a>
            <!--            <a target="_blank" :href="`libaoge/#/${item}?locale=`+$i18n.locale">{{-->
            <!--                $t('group.header.hover.food.' + item)-->
            <!--              }}</a>-->
          </li>
        </ul>
      </div>
    </div>
    <div class="w-1/3 flex justify-center">
      <div class="flex items-center">
        <div class="cursor-pointer hover:underline text-md">
          <a href="#/coffee" target="_blank" class="block text-center">
            <span>{{ $t('group.header.hover.coffee.title') }}</span>
            <img src="@/assets/coffee-main.jpg" class="w-24 h-24 mt-1" alt="">
          </a>
        </div>
        <ul class="ml-16">
          <li v-for="(item, index) in coffee" :key="index" @click="openHover(item)"
              class="py-1 cursor-pointer hover:underline text-md">
            {{ $t('group.header.hover.coffee.' + item) }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>